import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoResultsLabelComponent } from './no-results-label.component';

@NgModule({
  declarations: [NoResultsLabelComponent],
  imports: [CommonModule],
  exports: [NoResultsLabelComponent],
})
export class NoResultsLabelModule {}
